import angular from 'angular';

angular
  .module('cloudX')
  .controller('RelationWizardDialogCtrl', [
    '$element',
    'appMessages',
    'close',
    'title',
    'wizardOptions',
    relationWizardDialogCtrl,
  ]);

function relationWizardDialogCtrl($element, appMessages, close, title, wizardOptions) {
  var vm = this;
  vm.title = appMessages(title || 'New relation');

  vm.wizardOptions = wizardOptions || {};
  vm.success = function(relation, isNew) {
    if (relation && relation.id) {
      close(
        {
          relation: relation,
          isNew: isNew,
        },
        500,
      );
      $element.modal('hide');
    }
  };

  vm.cancel = function() {
    close(null, 500);
  };
}
